import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AppSharedModule } from 'app/app-shared.module';

import { AccountSharedModule } from './account-shared.module';
import { AccountDropdownComponent } from './components/account-dropdown/account-dropdown.component';
import { AccountDropdownWrapperComponent } from './components/account-dropdown-wrapper/account-dropdown-wrapper.component';
import { GroupDropdownWrapperComponent } from './components/group-dropdown-wrapper/group-dropdown-wrapper.component';
import { SessionExpirationWarningComponent } from './components/session-expiration-warning/session-expiration-warning.component';
import { LoginComponent } from './pages/login/login.component';

@NgModule({
  imports: [AppSharedModule, AccountSharedModule],
  declarations: [
    LoginComponent,
    AccountDropdownComponent,
    AccountDropdownWrapperComponent,
    GroupDropdownWrapperComponent,
    SessionExpirationWarningComponent,
  ],
  exports: [
    AccountDropdownWrapperComponent,
    GroupDropdownWrapperComponent,
    SessionExpirationWarningComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AccountModule {}
